// Map #3 Rust Canyon, audio half. Red badlands under a hard noon sun.
// Ambience: dry wind through the hoodoos with blowing grit (both swell hard in the dust storm), a low canyon air, vulture /
// hawk cries ringing off the walls, rockfall trickles, the odd insect, creaks from the old mine works; crickets and a far
// coyote-like howl at night. A long canyon echo.
// Music: A dorian frontier lope in 12/8 (84 bpm): twangy plucked arps, a trotting bass, a whistled lead with a long echo.
import { MODES, type MapAudioDef } from '../../audio/mapAudioDef';

export const AUDIO: MapAudioDef = {
  id: 'rust-canyon',
  ambience: {
    level: 1.24,
    beds: [
      { src: 'pink', filter: 'bandpass', freq: 700, q: 0.6, gain: 0.5, night: 0.7, storm: 2.5, gust: { depth: 0.6, every: [2.5, 7], sweep: 1.7 } },
      { src: 'white', filter: 'highpass', freq: 4500, gain: 0.05, night: 0.5, storm: 4, gust: { depth: 0.8, every: [2, 5] } },
      { src: 'brown', filter: 'lowpass', freq: 140, gain: 0.35 },
    ],
    events: [
      { kind: 'raptor', every: [12, 26], gain: 0.12, day: 1, night: 0, echo: 0.55 },
      { kind: 'rockfall', every: [10, 22], gain: 0.16, echo: 0.4 },
      { kind: 'gust', every: [7, 14], gain: 0.3, storm: 1.5 },
      { kind: 'insect', every: [15, 30], gain: 0.05, day: 1, night: 0.2 },
      { kind: 'cricket', every: [2, 4], gain: 0.04, day: 0, night: 1, voices: 2 },
      { kind: 'howl', every: [25, 50], gain: 0.07, day: 0.05, night: 1, echo: 0.6, pitch: 1.25 },
      { kind: 'creak', every: [25, 45], gain: 0.05, echo: 0.5 },
    ],
    echo: { l: 0.42, r: 0.63, fb: 0.42, damp: 1800, wet: 0.85 },
  },
  music: {
    mood: 'dusty frontier lope (A dorian, 12/8 at 84 bpm)',
    score: {
      bpm: 84, steps: 12, root: 45, mode: MODES.dorian, progression: [0, 3, 0, 6, 0, 3, 4, 0],
      pad: { wave: 'sawtooth', voices: 3, detune: 8, cutoff: 900, gain: 0.055, octave: 1, send: 0.3 },
      bass: { wave: 'triangle', cutoff: 900, atk: 0.005, dec: 0.2, sus: 0.6, rel: 0.1, gain: 0.4, octave: 0, legato: 0.8,
        pattern: '1..5..1..5..', hot: '1.15..1.15.8' },
      arp: { wave: 'sawtooth', cutoff: 1400, q: 3, env: 3, atk: 0.002, dec: 0.18, sus: 0.05, rel: 0.1, gain: 0.09, octave: 1, send: 0.45,
        pattern: [0, -1, 2, 3, -1, 2, 1, -1, 2, 3, -1, 2], hot: [0, 2, 3, 0, 2, 3, 1, 2, 4, 1, 2, 4] },
      lead: { wave: 'sine', cutoff: 4000, atk: 0.05, dec: 0.3, sus: 0.8, rel: 0.3, gain: 0.11, octave: 2, send: 0.55,
        vibrato: { rate: 5.5, cents: 25 }, bars: [2, 4, 6],
        motifs: [
          { notes: [[4, 3], [3, 3], [2, 3], [0, 3], [1, 6], [null, 6]] },
          { notes: [[0, 3], [2, 3], [4, 6], [5, 3], [4, 3], [2, 6]] },
          { notes: [[7, 6], [6, 3], [4, 3], [2, 6], [null, 6]] },
        ] },
      drums: { kit: 'frame', gain: 0.8,
        main: { kick: 'X.....X.....', snare: '...x.....x..', hat: 'x.gx.gx.gx.g' },
        fill: { tom: '......x.xX.X' },
        hot: { kick: 'X..x..X..x..', snare: '...X.....X.g', hat: 'xgxxgxxgxxgx', tom: '.........x.x' } },
      echo: { steps: 3, fb: 0.4, wet: 0.25, damp: 2000 },
      level: 0.74,
    },
  },
};
